module.exports = __webpack_public_path__ + "img/history-img.047f9973.jpg";